
export class Utility {

  static getCustomerId(): number | string {
    return JSON.parse(sessionStorage.getItem("profile")) ? String(JSON.parse(sessionStorage.getItem("profile")).customerId) : "none";
  }

  static getProfile() {
    return JSON.parse(sessionStorage.getItem("profile"));
  }

  static getCurrentRole(): number | string{
    return JSON.parse(sessionStorage.getItem("profile")) ? String(JSON.parse(sessionStorage.getItem("profile")).role) : "none";
  }

  static getContractId(): number | string {
    return JSON.parse(sessionStorage.getItem("profile")) ? String(JSON.parse(sessionStorage.getItem("profile")).contactId) : "none";
  }

  static getCustomerReference(){
    return JSON.parse(sessionStorage.getItem("profile")) ? String(JSON.parse(sessionStorage.getItem("profile")).customerReference) : 'none'
  }

}